/**
 * Centralized theme constants for athlete-flow.
 * Ensures consistent dark mode styling across all components.
 */

// ─── Color Scheme ──────────────────────────────────────────────────────────

export const COLORS = {
  // Lime accent — primary action color
  lime: {
    solid: '#C0FD72',
    hover: '#b0ef62',
  },
  // Text colors for dark theme
  text: {
    primary: 'text-white',
    secondary: 'text-gray-300',
    muted: 'text-gray-400',
    mutedHover: 'text-gray-300',
  },
  // Border colors for dark theme
  border: {
    subtle: 'border-white/5',
    light: 'border-white/10',
    lighter: 'border-white/15',
    lightest: 'border-white/20',
  },
  // Background colors for dark theme
  bg: {
    card: 'bg-white/10',
    cardSubtle: 'bg-white/5',
    hover: 'bg-white/10',
    hoverLight: 'bg-white/5',
  },
}

// ─── Button Class Presets ─────────────────────────────────────────────────

export const BUTTON_CLASSES = {
  // Primary action button — lime
  lime: 'bg-[#C0FD72] text-black hover:bg-[#b0ef62] font-semibold',

  // Secondary action button — dark outline
  darkOutline:
    'border border-white/15 text-gray-300 bg-transparent hover:bg-white/5 hover:text-white',

  // Subtle secondary button
  darkGhost: 'text-gray-300 hover:text-white hover:bg-white/5',
}

// ─── Card Class Presets ──────────────────────────────────────────────────

export const CARD_CLASSES = {
  // Dark card — use with cn() when a plain <div> is needed instead of <Card>
  dark: 'bg-white/10 backdrop-blur-xs border border-white/5 rounded-3xl rounded-bl-none shadow-lg',
}

// ─── Input Class Presets ─────────────────────────────────────────────────

export const INPUT_CLASSES = {
  // Dark input field
  dark: 'bg-white/5 border-white/10 text-white',
}

// ─── Dialog Class Presets ────────────────────────────────────────────────

export const DIALOG_CLASSES = {
  // Dark content background
  dark: 'bg-[#10181D] border-white/10 text-white',
}
